interface State {
  bannerEntries: {}
  path: string
}

const defaultState: State = {
  bannerEntries: {},
  path: ''
}

const state: State = Object.assign({}, defaultState)

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },

  setBannerEntries(state: State, payload: any) {
    state.bannerEntries[payload.key] = payload.banners
  },
  setPath(state: State, path: string) {
    state.path = path
  }
}

const actions = {}

const getters = {
  bannerEntries: (state: State): {} => state.bannerEntries,
  path: (state: State): {} => state.path
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
